import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import About from "../components/About/About";
import Services from "../components/Services/Services";
import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";
import Realisations from "../components/Realisations/Realisation";
import Valeurs from "../components/Valeurs/Valeurs"
import DroneCleaning from "../components/DroneCleaning/DroneCleaning"

export default function Home() {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <DroneCleaning />
      <Valeurs />
      <About />
      <Realisations />
      <Contact />
      <Footer />
    </>
  );
}